export const isReplacement = (e: InputEvent) => e.inputType === 'insertReplacementText';
